import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import Renderable from '../../../Component/Renderable';
import Interactable from '../../../Component/Interactable';

export class OverlayFadeIn extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        renderable.visible = true;

        const interactable: Interactable = gameObject.getComponent(Interactable);
        interactable.enabled = true;

        const fadeInTween: Tween = this.getTween(renderable);

        fadeInTween.to({ alpha: 1 }, 500).easing(Easing.Linear.None);

        yield* this.startTween(fadeInTween);
    }
}
